module.exports = __webpack_public_path__ + "img/icon_pay_way.5bef6876.png";